import React from 'react';
import PropTypes from 'prop-types';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import PDPDimensionsContentUI from './PDPDimensionsContentUI';

const PDPDimensionsContent = ({
  isSidebarContent,
  onImageClick,
  pageLoading = false,
}) => {
  const {
    loading,
    error,
    data: { dimensions, custom_properties },
  } = useProductAttributes();

  if (error) {
    return null;
  }

  return (
    <PDPDimensionsContentUI
      loading={loading || pageLoading}
      dimensionsDesktopImage={custom_properties?.dimensional_image_desktop}
      dimensionsMobileImage={custom_properties?.dimensional_image_mobile}
      dimensions={dimensions}
      onImageClick={onImageClick}
      isSidebarContent={isSidebarContent}
    />
  );
};

PDPDimensionsContent.propTypes = {
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  pageLoading: PropTypes.bool,
};

export default PDPDimensionsContent;
